import React, { useEffect, useState } from "react";

import * as moment from "moment";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Row
} from "../../components/Component";
import { GET, POST, PUT } from "../../helper/api";
import { formatDateYMD, getDefaultTransactionHistory } from "../../utils/Utils";
import UpsertPNTransactionHistoryComponent from './upsert-pn-transaction-history-component/UpsertPNTransactionHistoryComponent';
import { buildLabelMortgageContract } from "../../helper/mortgage-contract";

const PNUpsertTransactionHistory = ({
  type,
  id: initId,
  duplicateId,
  defaultValue = {},
  onClose
}) => {
  const methodForm = useForm({
    defaultValues: getDefaultTransactionHistory(defaultValue),
  });

  const {
    reset,
    getValues,
    watch,
    register,
    errors,
    control,
    handleSubmit,
  } = methodForm
  let id = initId !== 'add' ? (duplicateId || initId) : undefined;
  const isEdit = initId && initId !== 'add' && !duplicateId;
  const [defaultMortgageContractOption, setSefaultMortgageContractOption] = useState([]);

  useEffect(() => {
    if (id) {
      GET(`/pn-transaction-history/${id}`, {}, true).then((resp) => {
        reset(resp.data);

        if (resp.data.contractId) {
          const c = resp.data.mortgageContract;
          setSefaultMortgageContractOption([{
            label: buildLabelMortgageContract(c),
            value: c.contractId,
            data: c,
          }]);
        }
      });
    }
  }, [])

  const parseDataSubmit = (payload) => {
    const {
      address,
      amount,
      bankAccountId,
      categoryId,
      content,
      date,
      receiver,
      contractId,
      fund,
      fundUSD,
      interest,
      interestUSD,
      exchangeInterestRate,
      exchangeRate,
      amountUSD,
      currency,
      reason,
      reviewerId,
      pnHookTransactionHistoryId,
    } = payload;

    const formData = {
      amount,
      bankAccountId,
      categoryId,
      content,
      receiver,
      address,
      date: moment(date).format(formatDateYMD),
      type,
      pnHookTransactionHistoryId: pnHookTransactionHistoryId ? Number(pnHookTransactionHistoryId) : null,
      exchangeRate,
      amountUSD,
      currency,
      contractId: contractId || null,
      fundUSD,
      interestUSD,
      exchangeInterestRate,
      ...(contractId ? {
        fund,
        interest,
      } : {}),
      reason,
      reviewerId,
    };
    return formData;
  }
  // Submits form data
  const onHandleSubmit = () => {
    const formData = parseDataSubmit(getValues())

    const request = isEdit
      ? PUT(`pn-transaction-history/${id}`, formData, {}, true)
      : POST("pn-transaction-history", formData, {}, true);

    request
      .then(() => {
        if (isEdit) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
  };

  return (
    <div className="card card-bordered card-preview">
      <div className="card-inner">
        <h3>
          {!isEdit ? "Thêm" : "Sửa"} tiền {type === "IN" ? "thu" : "chi"}

        </h3>
        <FormProvider {...methodForm}>
          <UpsertPNTransactionHistoryComponent defaultMortgageContractOptions={defaultMortgageContractOption} type={type} />
          <Row>
            <Col size="12" className={"mt-4"}>
              <Button color="primary" type='button' className={`mr-2`} onClick={handleSubmit(onHandleSubmit)}>
                <span>Lưu giao dịch</span>
              </Button>
            </Col>
          </Row>
        </FormProvider>


      </div>
    </div>
  );
};

export default PNUpsertTransactionHistory;
